<template>
  <div class="app-wrap">
    <div :span="24" class="h100 overflow-x-y" style="overflow-y: auto; background: #f6f6f6">
      <div class="search padding24">
        <el-form :inline="true" class="flex-alignend" :model="searchForm" @submit.native.prevent>
          <!-- <el-form-item>
            <el-select v-model.trim="searchForm.model" placeholder="请选择模块">
              <el-option v-for="item in modeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-select
              v-model="searchForm.createBy"
              v-loadmore="userLoadMore"
              class="edm-date-picker--width"
              placeholder="全部操作人"
              filterable
              remote
              clearable
              value-key="id"
              :remote-method="userRemoteMethod"
              @visible-change="userFocus"
              @change="userChange"
            >
              <template v-for="(item) in userTableData">
                <el-option v-show="!item.hidden" :key="item.id" :label="`${item.displayName}-${item.username}`" :value="item.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.state" placeholder="请选择导入状态">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- 搜索框 end-->
      <!-- 主题内容 start -->
      <div class="content-wrap padding24">
        <el-tabs v-model="importOrExportType">
          <el-tab-pane label="导入" name="import">
            <excel-record type="IMPORT" :query-data="queryData"></excel-record>
          </el-tab-pane>
          <el-tab-pane label="导出" name="export">
            <excel-record type="EXPORT" :query-data="queryData"></excel-record>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from "@/api/user/user";
import ExcelRecord from "./record";
export default {
  name: "ExcelImportRecord",
  components: { ExcelRecord },
  data() {
    return {
      importOrExportType: "import",
      searchForm: {
        model: -1,
        state: -1,
        createBy: ""
      },
      statusOptions: [
        {
          label: "全部",
          value: -1
        },
        {
          label: "失败",
          value: "FAILED"
        },
        {
          label: "成功",
          value: "SUCCEED"
        },
        {
          label: "进行中",
          value: "PROCESSING"
        }
      ],
      list: [],
      userPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      userTableData: [],
      searchUserFormValue: "",
      modeList: [
        {
          name: "全部模板",
          code: -1
        },
        {
          name: "设备台账",
          code: "scim-edm-equipment-info"
        }
      ]
    };
  },
  computed: {
    queryData() {
      const { model, state, createBy } = this.searchForm;
      const queryData = {};
      if (model !== -1) {
        queryData.templateCode = model;
      }

      if (state !== -1) {
        queryData.state = state;
      }

      if (createBy) {
        queryData.createBy = createBy;
      }

      return queryData;
    }
  },
  methods: {
    userLoadMore() {
      const { pageNum, pageSize} = this.userPagination;
      const totalPage = Math.ceil(this.userPagination.total / this.userPagination.pageSize);
      const data = this.userTableData.filter(item => !item.hidden);
      if ((data.length === pageNum * pageSize) && pageNum < totalPage) {
        this.userPagination.pageNum++;
        this.getUserPageList();
      }
    },
    userRemoteMethod(query) {
      if (query !== "") {
        this.searchUserFormValue = query;
      } else {
        this.searchUserFormValue = "";
      }
      this.userPagination.pageNum = 1;
      this.userTableData = [];
      this.getUserPageList();
    },
    userFocus(val) {
      if (val) {
        this.userPagination.pageNum = 1;
        this.searchUserFormValue = "";
        this.userTableData = [];
        this.getUserPageList();
      }
    },
    getUserPageList() {
      const params = {
        page: this.userPagination.pageNum,
        size: this.userPagination.pageSize,
        orgId: this.$store.getters.tenantId,
        penetrateOrg: true
      };
      if (this.searchUserFormValue.trim()) {
        params["search"] = this.searchUserFormValue;
      };
      userApi.getUserPage(params, { useCancelToken: true }).then(res => {
        if (res.success) {
          const { data } = res;
          if (data) {
            const { records = [], total = 0 } = data;
            this.userTableData = [...this.userTableData, ...records];
            this.userPagination.total = Number(total);
          }
        }
      });
    },
    userChange(id) {
      if (id) {
        this.$set(this.searchForm, "createBy", id);
      } else {
        this.searchForm.createBy = "";
      }
    }
  }
};
</script>

<style  lang="scss" scoped>
.padding24 {
  padding: 24px 24px 0;
}
.content-wrap {
  background: #fff;
  margin-top: 8px;
  height: calc(100% - 90px);
}
.search {
  background: #fff;
}
</style>
